import React from 'react';
import AttachmentCard from '../../AttachmentCard';
import './GridDisplay.scss';

const GridDisplay = ({
  attachments,
  editable,
  onDelete,
  onOrderUpdate,
  onEditComplete,
  showInfo,
  thumbnailSize,
  refreshKey,
  onImageClick,
  className = ""
}) => {
  return (
    <div className={`attachments-grid ${className}`}>
      {attachments.map((attachment, index) => (
        <AttachmentCard
          key={`${attachment.id}-${refreshKey}`}
          attachment={attachment}
          editable={editable}
          onDelete={() => onDelete(attachment.id)}
          onOrderUpdate={(direction) => onOrderUpdate(attachment.id, direction)}
          onEditComplete={onEditComplete}
          showOrderControls={editable && attachments.length > 1}
          canMoveUp={index > 0}
          canMoveDown={index < attachments.length - 1}
          showInfo={showInfo}
          thumbnailSize={thumbnailSize}
          onImageClick={() => onImageClick?.(attachment.id)}
        />
      ))}
    </div>
  );
};

export default GridDisplay;